import { useHistory } from "react-router-dom";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent,
  IonIcon,
  IonSpinner,
  IonButton,
  IonButtons,
  IonMenuButton,
} from "@ionic/react";
import React, { useState, useRef } from "react";
import { add as addIcon } from "ionicons/icons";
import "moment/locale/es";
import AuthService from "../services/auth.service";
import { useTranslation } from "react-i18next";
import "./Pages.css";
interface PageProps {
  pageName: string | undefined;
}

const ContactPage: React.FC<PageProps> = ({ pageName }, location) => {
  const history = useHistory();
  const fileInput = useRef(null);
  const { t } = useTranslation();
  const [currentUser, setCurrentUser] = useState(AuthService.getCurrentUser());
  const [condominioId, setCondominioId] = useState(
    currentUser.condominioId ? currentUser.condominioId : 0,
  );

  const [image, setImage] = useState("");
  const [file, setFile] = useState(null);
  const [imageChange, setImageChange] = useState(false);
  const [lang, setLang] = useState<string>(
    localStorage.getItem("langSelect")
      ? localStorage.getItem("langSelect")!
      : "en",
  );



  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons>
            <IonMenuButton />
            <IonTitle>{t("contacts")}</IonTitle>
            <IonButton
              slot="end"
              fill="clear"
              routerLink={"/page/contacts/new"}
            >
              <IonIcon icon={addIcon} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {false ? (
          <div className="spin">
            <IonSpinner></IonSpinner>
          </div>
        ) : (
          <>
            <IonCard>
              <img
                alt="Silhouette of mountains"
                src="https://ionicframework.com/docs/img/demos/card-media.png"
                style={{ maxWidth: "100%", height: "186px", width: "40%" }}
              />
              <IonCardHeader>
                <IonCardTitle>Contacto</IonCardTitle>
                <IonCardSubtitle>Datos de Contacto</IonCardSubtitle>
              </IonCardHeader>

              <IonCardContent>Nombre</IonCardContent>

              <IonCardContent>Dirección</IonCardContent>
            </IonCard>
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default ContactPage;
